import { render, staticRenderFns } from "./Gmxkzwsytx.vue?vue&type=template&id=0bf85a46&scoped=true&"
import script from "./Gmxkzwsytx.vue?vue&type=script&lang=js&"
export * from "./Gmxkzwsytx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf85a46",
  null
  
)

export default component.exports